import { CHART_SERIES, IndexData } from "../components/Chart/utils";

export const getIndexLabel = (indexName: string): string =>
  CHART_SERIES.find(({ id }) => id === indexName)?.label || "";

export const getLastPriceFromIndexData = (
  indexData: IndexData[],
  indexId = "emIndex",
) => {
  const indexLabel = getIndexLabel(indexId);
  return [...indexData]
    .reverse()
    .find(({ index_entries }) =>
      index_entries.find(({ index_type }: any) => index_type === indexLabel),
    )
    ?.index_entries.filter(({ index_type }: any) => index_type === indexLabel)
    .map(({ index_value }: any) => index_value)[0];
};

export const getLastDateFromIndexData = (indexData: IndexData[]) =>
  [...indexData].reverse()[0]?.date;

export const getLastChangeFromIndexData = (
  indexData: IndexData[],
  indexId = "emIndex",
) => {
  const lastPrice = getLastPriceFromIndexData(indexData, indexId);
  const penultimateIndexData = [...indexData.slice(-2, -1)];
  const penultimatePrice = getLastPriceFromIndexData(
    penultimateIndexData,
    indexId,
  );

  return lastPrice / penultimatePrice;
};
